/* @flow */
export default function routeForEndpoint(endpoint: string): string {
  const tokens = endpoint.substring(1).split('/'); // drop the leading slash
  const routeTokens = tokens.map(token => {
    if (!isNaN(token)) {
      return '{id}';
    }
    if (token.includes('-')) {
      return '{uuid}';
    }
    return token;
  });
  return routeTokens.join('/');
}
